import ExhibitorsContainer from "../../../Component/Application/Exhibitors/ExhibitorsContainer";

const ExhibitorsPage = () => {
    return (
        <div className="page-body">
            <ExhibitorsContainer />
        </div>
    );
};

export default ExhibitorsPage;